/**
 * Floating "scroll to top" button. Becomes visible once the user scrolls past
 * the first viewport-height fold, and smoothly scrolls back to the top on click.
 */
class ScrollToTopComponent extends HTMLElement {
  #onScroll = () => {
    const threshold = window.innerHeight;
    this.toggleAttribute('visible', window.scrollY > threshold);
  };

  #onClick = () => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
  };

  connectedCallback() {
    this.#onScroll();
    window.addEventListener('scroll', this.#onScroll, { passive: true });
    window.addEventListener('resize', this.#onScroll, { passive: true });
    this.querySelector('button')?.addEventListener('click', this.#onClick);
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.#onScroll);
    window.removeEventListener('resize', this.#onScroll);
    this.querySelector('button')?.removeEventListener('click', this.#onClick);
  }
}

if (!customElements.get('scroll-to-top')) {
  customElements.define('scroll-to-top', ScrollToTopComponent);
}
